import React from 'react'
import { usePaginationFragment, graphql } from 'react-relay'

import { EventsScreenList_query$key } from './__generated__/EventsScreenList_query.graphql'

import { EventList } from '@newComponents'

export const EventsScreenList = ({
  query,
}: {
  query: EventsScreenList_query$key
}) => {
  const { data, hasNext, loadNext } = usePaginationFragment(
    graphql`
      fragment EventsScreenList_query on Query
      @refetchable(queryName: "EventsScreenListPaginationQuery")
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 10 }
        cursor: { type: "Cursor" }
      ) {
        upcomingEvents: eventsByTimeSelection(
          timeSelection: UPCOMING
          first: $count
          after: $cursor
          filter: {
            and: [
              { not: { metadata: { containsKey: "meetupEventID" } } }
              { allowGlobalListing: { equalTo: true } }
            ]
          }
        ) @connection(key: "EventsScreenList_query_upcomingEvents") {
          edges {
            cursor
          }

          ...EventList_eventsConnection
        }

        ...EventList_query
      }
    `,
    query
  )

  if (!data.upcomingEvents) {
    return null
  }

  return (
    <EventList
      eventsConnection={data.upcomingEvents}
      query={data}
      hasNext={hasNext}
      loadNext={loadNext}
      showEndOfListPlaceholder
    />
  )
}
